import React from 'react'
import { Route } from 'react-router-dom'
import ChannelsConfigurations from '../../../../components/ChannelView'

const ChannelsConfigurationsRoutes = ({ match }) => (
  <Route exact path={[match.path, `${match.path}/:id`]} component={ChannelsConfigurations} />
)

export default ChannelsConfigurationsRoutes
